import type { AssetFileDoc } from '@bb/domain/dist/schemas';
import axios from 'axios';

export type GetFilesParams = {
  folderId?: string;
  page: number;
  limit: number;
};

export type GetFilesResponse = {
  assets: AssetFileDoc[];
  totalAssets: number;
};

export const getFiles = async ({ folderId, page, limit }: GetFilesParams) => {
  const endpoint = folderId ? `/asset/file/${folderId}` : `/asset/file`;

  const { data } = await axios.get<GetFilesResponse>(endpoint, {
    params: { page, limit },
  });
  return data;
};
